import { RequestMainService } from "../request";

export class FirmwareService {
  static async getList(params: any = {}) {
    return RequestMainService.get(`/admin/firmwares`, params).then(
      ({ result }) => {
        return {
          count: result?.total,
          data: result.firmwares,
        };
      }
    );
  }

  static async create(params: any = {}) {
    return RequestMainService.post(`/admin/firmwares`, params).then(
      ({ result }) => {
        return result;
      }
    );
  }

  static async update(id: string, params: any = {}) {
    return RequestMainService.put(`/admin/firmwares/${id}`, params).then(
      ({ result }) => {
        return result;
      }
    );
  }

  static async delete(id: string) {
    return RequestMainService.delete(`/admin/firmwares/${id}`).then(
      ({ result }) => {
        return result;
      }
    );
  }

  static async getDetail(id: string) {
    return RequestMainService.get(`/admin/firmwares/${id}`).then(
      ({ result }) => {
        return result;
      }
    );
  }

  static async import(params: any) {
    return RequestMainService.uploadFile(
      `/admin/firmwares/import`,
      params
    ).then((res) => res?.data);
  }
}
